import { render, staticRenderFns } from "./ConvertJap.vue?vue&type=template&id=b20061ee&scoped=true"
import script from "./ConvertJap.vue?vue&type=script&lang=js"
export * from "./ConvertJap.vue?vue&type=script&lang=js"
import style0 from "./ConvertJap.vue?vue&type=style&index=0&id=b20061ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20061ee",
  null
  
)

export default component.exports